module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl pos-rel after-bg-wh",
    class: {
      'drag': _vm.isDrag || _vm.isSort
    },
    style: ('width:' + _vm.width + ';height:' + _vm.height),
    on: {
      "mouseup": function($event) {
        _vm.dragUp($event)
      },
      "mouseleave": _vm.resetAndDeleteInsertPos,
      "mouseover": function($event) {
        _vm.showInsertPos($event, -1, {})
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curSort.default.type),
      expression: "curSort.default.type"
    }],
    staticClass: "temp-sort",
    style: (_vm.dragStyle)
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "m-l-10 max-w-400 text-ovferflow"
  }, [_vm._v(_vm._s(_vm.curSort.default.title))])]), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "input-list bor-deep-gra h-100p ovf-auto"
  }, [(!_vm.isChild) ? _c('div', {
    staticClass: "c-deep-blue p-t-10 p-b-10 p-l-10 m-t-0 m-b-0 bor-b-gray fw-b"
  }, [_vm._v("\n      表单："), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputListModel),
      expression: "inputListModel"
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.inputListModel)
    },
    on: {
      "input": function($event) {
        _vm.inputListModel = $event
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInputListEmpty),
      expression: "isInputListEmpty"
    }],
    staticClass: "pos-abs",
    staticStyle: {
      "z-index": "-1"
    }
  }, [_vm._v("请拖拽控件到此区域")]), _vm._v(" "), _vm._l((_vm.inputList), function(item, index) {
    return (item.default && !item.default.is_deleted) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.hide),
        expression: "!item.hide"
      }],
      class: {
        'active-input': item.selected, 'temp-input': item.temp, 'dulpicate': item.isDulpicate
      },
      on: {
        "mouseover": function($event) {
          _vm.showInsertPos($event, index, item)
        },
        "click": function($event) {
          _vm.beforeSelectInput($event, item)
        }
      }
    }, [(!item.temp) ? _c('span', {
      staticClass: "fl"
    }, [_c('div', {
      staticClass: "drag-shank",
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "mousedown": function($event) {
          _vm.sortDown(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrows fz-24 c-blue"
    })])]) : _vm._e(), _vm._v(" "), (!item.temp) ? _c('span', {
      staticClass: "m-l-10 fl input-title text-overflow",
      attrs: {
        "title": item.default.title
      }
    }, [_vm._v(_vm._s(item.default.title))]) : _vm._e(), _vm._v(" "), (!item.temp) ? _c('div', {
      staticClass: "m-l-20 fl"
    }, [(item.default.type == _vm.TYPE_INPUTTEXT || item.default.type == _vm.TYPE_PASSWORD) ? _c('el-input', {
      staticClass: "h-40 w-150",
      attrs: {
        "disabled": true
      }
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_TEXTAREA) ? _c('el-input', {
      staticClass: "h-50 w-150",
      attrs: {
        "type": "textarea",
        "disabled": true
      }
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_RADIO) ? _c('el-radio', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("选项")]) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_CHECKBOX) ? _c('el-checkbox', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("选项")]) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_SELECT || item.default.type == _vm.TYPE_CASCADER) ? _c('el-select', {
      staticClass: "w-150",
      attrs: {
        "disabled": "",
        "placeholder": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_DATE || item.default.type == _vm.TYPE_BOTH_DATE_TIME) ? _c('el-date-picker', {
      staticClass: "w-150",
      attrs: {
        "disabled": "",
        "type": "date"
      }
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_TIME) ? _c('el-time-select', {
      staticClass: "w-150",
      attrs: {
        "disabled": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_FILE) ? _c('i', {
      staticClass: "fa fa-upload c-blue fz-24"
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_EDITOR) ? _c('i', {
      staticClass: "fa fa-wpforms c-blue fz-24"
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_FOREIGNKEY) ? _c('i', {
      staticClass: "fa fa-reply-all c-blue fz-24"
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_MULTIRELATE) ? _c('i', {
      staticClass: "fa fa-asterisk c-blue fz-24"
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_SUBFORM) ? _c('i', {
      staticClass: "fa fa-th c-blue fz-24"
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_PERSON) ? _c('i', {
      staticClass: "fa fa-user-o c-blue fz-24"
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_STRUCT) ? _c('i', {
      staticClass: "fa fa-users c-blue fz-24"
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_USER) ? _c('i', {
      staticClass: "fa fa-address-card c-blue fz-24"
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_DEALTIME) ? _c('i', {
      staticClass: "fa fa-calendar c-blue fz-24"
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_PARAMS) ? _c('i', {
      staticClass: "fa fa-file-code-o c-blue fz-24"
    }) : _vm._e(), _vm._v(" "), (item.default.type == _vm.TYPE_SUBRELATE) ? _c('i', {
      staticClass: "fa fa-cogs c-blue fz-24"
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.temp && item.default.is_system != 1) ? _c('span', {
      staticClass: "fr"
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteInput($event, item, index)
        }
      }
    }, [_vm._v("删除")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (!item.temp && item.default.type == _vm.TYPE_SUBFORM) ? _c('div', {
      staticClass: "subform-area",
      on: {
        "mouseover": _vm.resetAndDeleteInsertPos,
        "click": function($event) {
          _vm.cancelSelectParent($event)
        }
      }
    }, [_c('input-list', {
      ref: "inputList",
      refInFor: true,
      attrs: {
        "inputList": item.form.data,
        "width": "100%",
        "height": "300px",
        "curType": _vm.curType,
        "curInput": _vm.curInput,
        "isDrag": _vm.isDrag,
        "isChild": true
      },
      on: {
        "setCurInput": _vm.setCurInput,
        "setIsDrag": _vm.setIsDrag,
        "setCurType": _vm.setCurType,
        "resetFromChild": _vm.resetFromChild,
        "clearInputModel": _vm.clearInputModel
      }
    })]) : _vm._e()]) : _vm._e()
  })], true)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "drag-shank",
    attrs: {
      "size": "small",
      "type": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows fz-24 c-blue"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65e20b22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/inputList.vue
// module id = 1897
// module chunks = 2